import React, { useEffect, useState } from "react";
import Header from "./MainHeader";
import { Link } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";

const Main = () => {
    const images = [
        "https://privateequitybro.com/wp-content/uploads/building-8131375_1280.jpg",
        "https://live.staticflickr.com/65535/48971115011_afe9ae7b26_o.jpg",
        "https://i.pinimg.com/originals/4f/46/3a/4f463a7eadcb4b6878e1131bea9539d8.jpg",
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % images.length);
        }, 10000); // меняется каждые 10 секунд
        return () => clearInterval(interval);
    }, [images.length]);

    return (
        <div
            className="relative w-full md:h-[50vh] bg-center bg-cover flex items-center text-white transition-all duration-1000"
            style={{ backgroundImage: `url(${images[currentIndex]})` }}
        >
            <div className="absolute inset-0 bg-black/70"></div>
            <div className="relative w-full z-10 mx-auto">
                <Header />
                <div className="container p-5 md:p-0 md:min-h-[25vh] md:mt-12 pb-5 gap-2 items-center text-white flex flex-col justify-around">
                    <h1 className="font-bold text-center text-lg md:text-2xl">
                        Хотите продать свою недвижимость, но не знаете куда <br />{" "}
                        разместить свою рекламу?
                    </h1>
                    <p className="text-[12px] text-center md:text-base">
                        Вы можете разместить свою рекламу на нашем сайте совершенно
                        БЕСПЛАТНО.
                    </p>
                    <div>
                        <Link
                            to={
                                useAuthStore.getState().token
                                    ? `/detail/create/`
                                    : `/detail/login/`
                            }
                        >
                            <button className="button font-bold bg-[#e67e22] md:py-[10px] py-1.5 px-3 md:px-5 tracking-[1px] rounded-[20px]">
                                СОЗДАТЬ ОБЪЯВЛЕНИЯ
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Main;
